import { getAccessibleTransactions } from "./messaging/scope";

export function deskTransactions(session, listAgentId, excludeAgentId) {
  const rows = getAccessibleTransactions(session);
  if (listAgentId) return rows.filter((item) => item.agent_id === listAgentId);
  if (excludeAgentId) return rows.filter((item) => item.agent_id && item.agent_id !== excludeAgentId);
  return rows;
}
